<template>
  <div class="score-board">
    <div class="high-score">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
        <path
          d="M17 3H7c-1.1 0-2 .9-2 2v3c0 3.31 2.69 6 6 6v3H8v2h8v-2h-3v-3c3.31 0 6-2.69 6-6V5c0-1.1-.9-2-2-2zm0 5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5h8v3z" />
      </svg>
      {{ highScore }}
    </div>
    <div class="score" :class="{ highlight: isHighScoreAnimated }">{{ scoreDisplay }}</div>
  </div>
</template>

<script>
export default {
  name: 'ScoreBoard',
  props: {
    highScore: {
      type: Number,
      required: true
    },
    scoreDisplay: {
      type: Number,
      required: true
    },
    isHighScoreAnimated: {
      type: Boolean,
      required: true
    }
  }
};
</script>